import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'ark-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  @Input() label: string;
  @Input() link: string;

  constructor() { }

  ngOnInit() {
  }

}
